<template>
  <v-dialog v-model="dialog" max-width="700px" @click:outside="closed">
    <v-card :loading="loading" :disabled="loading">
      <v-card-title class="justify-center">
        <span class="text-h5">{{ $t('conglomerates.create') }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row class="d-flex flex-column mb-4">
            <span class="body black--text my-1">{{ $t('conglomerates.conglomerate_name') }}*</span>
            <v-text-field
              v-model="form.name"
              filled
              flat
              dense
              :error="showErrors && !form.name"
            />
          </v-row>

          <v-row class="d-flex flex-column mb-4">
            <span class="body black--text my-1">{{ $t('conglomerates.country') }}*</span>
            <v-autocomplete
              v-model="form.countryId"
              :items="countries"
              item-value="id"
              item-text="name"
              filled
              flat
              dense
              :error="showErrors && !form.countryId"
              hide-details
            />
          </v-row>

          <v-row class="d-flex flex-column mb-2">
            <span class="body black--text my-1">{{ $t('conglomerates.status') }}</span>
            <v-switch
              v-model="form.active"
              :label="form.active ? $t('conglomerates.active') : $t('conglomerates.inactive')"
              inset
            />
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="px-6 pb-6">
        <v-spacer />
        <v-btn text @click="closed">{{ $t('common.cancel') }}</v-btn>
        <v-btn color="deep-purple" dark @click="save">{{ $t('common.create') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SnackbarMixin from '@/mixins/snackbar';
import conglomerateService from '@/services/conglomerate.service';

export default {
  name: 'CreateConglomerateModal',
  mixins: [SnackbarMixin],
  props: {
    value: { type: Boolean, default: false },
    countries: { type: Array, default: () => [] },
  },
  data: () => ({
    loading: false,
    showErrors: false,
    form: {
      name: '',
      countryId: null,
      active: true,
    },
  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    closed() {
      this.dialog = false;
      this.showErrors = false;
      this.form = { name: '', countryId: null, active: true };
    },
    async save() {
      this.showErrors = true;
      if (!this.form.name || !this.form.countryId) {
        this.snackbarError(this.$t('conglomerates.error_validation'));
        return;
      }

      this.loading = true;
      try {
        const res = await conglomerateService.create({
          name: this.form.name,
          countryId: this.form.countryId,
          active: this.form.active,
        });

        if (res?.status === 'OK') {
          this.snackbarSuccess(this.$t('conglomerates.create_success'));
          this.$emit('created');
          this.closed();
        } else {
          this.snackbarError(this.$t('conglomerates.error_saving'));
        }
      } catch (error) {
        this.snackbarError(this.$t('conglomerates.error_saving'));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
